import axios from '../../../../utils/api'

const actions = {
  async save ({ commit }, data) {
    const result = await axios({
      url: '/assinatura-pdf/save',
      data,
      method: 'POST'

    })

    return result
  },
  async findAll ({ commit }) {
    const result = await axios({
      method: 'GET',
      url: `/assinatura-pdf/findAll`,
      error: true
    })

    return result
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/seguranca/assinaturaPdf.js